import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { Tabs } from '../../../../common/tabs'
import { CORPORATE_TYPE, FINANCIAL_TYPE } from '../../common/constant'
import { selectFinancials } from '../../common/store/slice'
import classes from './index.module.scss'
import { IndicatorItem } from './IndicatorItem'
import { SearchFinancial } from './SearchFinancial'

export const AddInfo = () => {
  const financials = useSelector(selectFinancials)

  const [activeTab, setActiveTab] = useState(FINANCIAL_TYPE.BALANCE_SHEET)
  const [activeCorporateType, setActiveCorporateType] = useState(
    CORPORATE_TYPE.CORPORATE,
  )

  const onChangeTab = (key) => {
    setActiveTab(key)
  }

  const onChangeCorporateType = (type) => {
    setActiveCorporateType(type)
  }

  const renderIndicators = () => {
    const data = financials[activeCorporateType][activeTab]
    return (
      <Element style={{ color: '#3A414B' }}>
        {data.map((item, index) => {
          return (
            <IndicatorItem
              key={item.screeningIndicatorId}
              item={item}
              index={index}
            />
          )
        })}
      </Element>
    )
  }

  return (
    <Element className={classes.addInfo}>
      <Element className={`mt1 ${classes.px20}`}>
        <SearchFinancial />
      </Element>

      <Element className={classes.tabs} style={{ color: '#3A414B' }}>
        <Tabs
          items={[
            {
              key: FINANCIAL_TYPE.BALANCE_SHEET,
              label: 'screening.BALANCE_SHEET',
            },
            {
              key: FINANCIAL_TYPE.INCOME_STATEMENT,
              label: 'screening.INCOME_STATEMENT',
            },
            {
              key: FINANCIAL_TYPE.CASHFLOW_STATEMENT,
              label: 'screening.CASHFLOW_STATEMENT',
            },
            {
              key: FINANCIAL_TYPE.RATIOS,
              label: 'screening.RATIOS',
            },
          ]}
          activeKey={activeTab}
          onChange={onChangeTab}
          getAppendStyleItem={(active) => ({
            textShadow: active ? '0 0 0.3px currentcolor' : 'unset',
          })}
        />
      </Element>

      <Element className={classes.corporateType}>
        {Object.keys(CORPORATE_TYPE).map((key) => (
          <Element
            key={key}
            style={{
              color: key === activeCorporateType ? '#FFFFFF' : '',
              backgroundColor:
                key === activeCorporateType ? '#2C73E8' : '#F3F3F3',
            }}
            onClick={() => onChangeCorporateType(key)}
          >
            <Translate value={`screening.${key}`} />
          </Element>
        ))}
      </Element>

      <Element className={classes.indicators}>
        <ScrollComponent>
          <Element className={classes.px20}>{renderIndicators()}</Element>
        </ScrollComponent>
      </Element>
    </Element>
  )
}
